import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dgfilter"
})
export class DgFilter implements PipeTransform {
  transform(items: any[], searchDg: string): any[] {
    if (!items) return [];
    if (!searchDg) return items;
    searchDg = searchDg.toLowerCase();

    return items.filter(it => {
      return it.dijagnoza
        .toLowerCase()
        .replace(/\./g, "")
        .includes(searchDg);
    });
  }
}
